import { Schema } from 'normalizr';
import { apiAction, apiFetch } from 'utils';
import { customDuck } from 'utils/duckify';
import DuckEntity from './DuckEntity';

const entity = new DuckEntity('refunds', {
  schema: new Schema('refunds', {
    idAttribute: object => (object.id ? object.id : object.order_id)
  })
});

entity.newRefund = (orderId) => customDuck(entity, {
  load: () => apiAction(
    entity.types.GET_BEGIN, entity.types.GET_SUCCESS, entity.types.GET_ERROR,
    (state) => apiFetch.get(
      state,
      `${entity.config.apiPath}/new`,
      { ...entity.config.loadOptions, query: `order_id=${orderId}` }
    ),
    { id: orderId, order_id: orderId }, // DuckEntity expects and uses `id` for action.id?
    { [entity.config.jsonRoot]: entity.schema }
  ),
  read: (state) => entity.single(state, orderId)
});

const { reducer } = entity;
export { reducer as default, entity };
